<p-dialog header="Header" [(visible)]="visible" [modal]="true" [style]="{ width: '50%' }" [draggable]="false" [resizable]="false" (onHide)="onDialogClose()">
    <ng-template pTemplate="header">
      <span class="text-xl  font-bold"><i class="pi pi-bell"></i> Aviso</span>
    </ng-template>
    <p>¿Quiere remover el producto {{ product.productName }} del carrito de compras</p>
    <ng-template pTemplate="footer">
        <p-button label="Confirmar" (click)="borrar()"></p-button>
        <p-button label="Cancelar" (click)="cancelar()"></p-button>
    </ng-template>
</p-dialog>